import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import SearchBox from "./search-box";
import Loading from "../elements/loading";
import useInfiniteScroll from "../../hooks/use-infinite-scroll";
import { CSSTransition } from "react-transition-group";
import numeral from "numeral";

const ListboxContent = ({
  searchable,
  handleSearch,
  loading,
  children,
  filteredCount = 0,
  scrollFetch = () => {},
  disableSearch = false,
  setDisableShowSelected = () => {},
  maxSelections = 0,
  isMaxSelections = false,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const scrollableRef = useRef();
  const handleScrollFetch = () => scrollFetch(searchValue);
  useInfiniteScroll(scrollFetch ? handleScrollFetch : undefined, scrollableRef.current);

  useEffect(() => {
    setDisableShowSelected(searchValue !== "");
  }, [searchValue, setDisableShowSelected]);

  const loadingOrEmpty = () => {
    if (loading) return <Loading position="center" size="small" />;
    if (!filteredCount) return <li className="et-listbox--no-results">No results</li>;
  };

  return (
    <>
      {searchable && (
        <div className="et-listbox--search">
          <SearchBox
            disabled={disableSearch}
            placeholder="Search..."
            onChange={val => {
              setSearchValue(val);
              handleSearch(val);
            }}
          />

          <div className="et-listbox--search-count" role="status">
            {filteredCount} results shown.
          </div>
        </div>
      )}
      <div className={classNames("et-listbox--content-list", { "et-listbox--content-list-searchable": searchable })}>
        <CSSTransition in={isMaxSelections} timeout={500} classNames="et-listbox--max-warning-transition" unmountOnExit>
          <div className="et-listbox--max-warning">Select {numeral(maxSelections).format("0,0")} items max</div>
        </CSSTransition>
        <ul className="et-listbox--scrollable-content" ref={scrollableRef}>
          {loadingOrEmpty() || children}
        </ul>
      </div>
    </>
  );
};

ListboxContent.propTypes = {
  searchable: PropTypes.bool.isRequired,
  handleSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  filteredCount: PropTypes.number,
  scrollFetch: PropTypes.func,
  disableSearch: PropTypes.bool,
  setDisableShowSelected: PropTypes.func,
  maxSelections: PropTypes.number,
  isMaxSelections: PropTypes.bool,
};

export default ListboxContent;
